import { render, staticRenderFns } from "./MerchantPaymentConfigManage.vue?vue&type=template&id=0c6a2dde&scoped=true"
import script from "./MerchantPaymentConfigManage.vue?vue&type=script&lang=js"
export * from "./MerchantPaymentConfigManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6a2dde",
  null
  
)

export default component.exports